import React from 'react';
import { FaSistrix } from "react-icons/fa";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../elements/breadcrumb/BreadcrumbOne";
import CourseHome from '../../components/course/CourseHome';


const Course = () => {
    return (
        <>
            <SEO title="Digital Course " />
            
            <Layout>
                <BreadcrumbOne 
                    title="Learn and Grow Your Earning and Save  <br /> Your Time"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Course"
                />
                <div className="main-content">
                    {/* Start Blog Area  */}
                    <div className="rn-blog-area rn-section-gap">
                        <div className="container">
                            <div className="row row--30">
                                <div className="col-lg-12">
                                    <div className="row mt_dec--30 p-2">
                                        <CourseHome column="col-lg-4 col-md-6 col-12 mt--30" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Blog Area  */}
                </div>

            </Layout>
        </>
    )
}

export default Course
